import apiClient from './apiClient';

export const checkUsername = async username => {
  const { data } = await apiClient.get(
    `/check/username/${encodeURIComponent(username)}`
  );
  return data;
};

export const checkTeamName = async teamName => {
  teamName = encodeURIComponent(teamName);
  return await apiClient.get(`/check/team/${teamName}`, {
    validateStatus: status => (status >= 200 && status < 300) || status === 422 // Accept only 200 and 422 status codes
  });
};
